(function(global) {
    'use strict';

    function CustomersSlider() {
        this.peppermint = null;
        this.$slider = $('.home-customers-slider__slider');
        this.$slides = $('.home-customers-slider__slide');
        this.minHeight = 0;
        this.style = 0;
    }

    CustomersSlider.prototype.init = function() {
        var slider = this;
        var styleID = '#customers-slider-style';

        if (!$(styleID).length) {
            $('head').append('<style id="customers-slider-style"/>');
        }
        slider.style = $(styleID);

        slider.onResize();

        new Swiper('.home-customers-slider__slider', {
            wrapperClass: 'home-customers-slider__slider-wrap',
            slideClass: 'home-customers-slider__slide',
            nextButton: '.home-customers-slider__control-next',
            prevButton: '.home-customers-slider__control-prev',
            slidesPerView: 2,
            loop: true,
            pagination: '.home-customers-slider__bullets',
            bulletClass: 'home-customers-slider__bullets-item',
            bulletActiveClass: 'home-customers-slider__bullets-item--active',
            onInit: function() {
                slider.$slider.prepend($('.home-customers-slider__controls--inner'));
            },
            breakpoints: {
                1023: {
                    slidesPerView: 1
                }
            },
            threshold: 10
        });

        slider.addListener();
    };

    CustomersSlider.prototype.setMinHeight = function() {
        this.style.text('.home-customers-slider__slide-wrap { min-height: ' + this.minHeight + 'px !important }');
    };

    CustomersSlider.prototype.onResize = function() {
        var slider = this;

        slider.minHeight = 0;

        window.requestAnimationFrame(function() {
            slider.$slides.each(function(i, slide) {
                var height = $(slide).outerHeight();

                if ($(slide).outerHeight() > slider.minHeight) {
                    slider.minHeight = Math.round(height);
                }
            });
            slider.setMinHeight();
        });
    };

    CustomersSlider.prototype.addListener = function() {
        var slider = this;

        // $(window).on('orientationchange', function () {
        //     slider.minHeight = 0;
        //     // slider.setMinHeight();
        //     slider.onResize();
        // });

        $(window).resize(function() {
            slider.onResize();
        });
    };

    global.CustomersSlider = CustomersSlider || {};
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/includes/customers-slider.js